<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <app-alert-card size = 0 [showtext] = false></app-alert-card>
            </div>
            <div class="col-md-3">
                <app-events [showheader]=true ></app-events>

            </div>
        </div>
    </div>
</div>